export function isTrackInSet(x) {
    return x != null && typeof x.id == 'string' &&
        (typeof x.tempo == 'number') &&
        (typeof x.duration == 'number') &&
        (x.fileName == null || typeof x.fileName == 'string') &&
        (x.offset == null || typeof x.offset == 'number') &&
        (typeof x.url == 'string');
}
//# sourceMappingURL=TrackInSet.js.map